import { Temporal } from "temporal-polyfill";

import type {
  OrdersWidgetRollingTimeWindow,
  OrdersWidgetTimeWindow,
} from "./OrdersWidget.types";
import { ORDERS_ROLLING_TIME_WINDOWS } from "./OrdersWidget.types";

export const ORDERS_TIME_ZONE = "America/New_York";

export const isOrdersRollingTimeWindow = (
  timeWindow: OrdersWidgetTimeWindow,
): timeWindow is OrdersWidgetRollingTimeWindow =>
  (ORDERS_ROLLING_TIME_WINDOWS as readonly string[]).includes(timeWindow);

export const getRollingOrdersAfter = (
  timeWindow: OrdersWidgetRollingTimeWindow,
  now: Temporal.Instant = Temporal.Instant.fromEpochMilliseconds(Date.now()),
): string => {
  const zoned = now.toZonedDateTimeISO(ORDERS_TIME_ZONE);
  const earlier =
    timeWindow === "last24Hours"
      ? zoned.subtract({ hours: 24 })
      : timeWindow === "last3Days"
        ? zoned.subtract({ days: 3 })
        : timeWindow === "last7Days"
          ? zoned.subtract({ days: 7 })
          : zoned.subtract({ months: 1 });
  return earlier.toInstant().toString();
};
